const utils = require('frontend-controller/lib/utils')
const downloader = require('frontend-controller/client/downloader')
const genericModalController = require('frontend-controller/lib/controllers/modals/generic')

module.exports = {
    extends: [
        '/',
        'templates',
        'core',
        'form',
        'propertiesForm',
    ],

    config: {
        entityContext: 'employees',
        preventClearOnCancel: true,
        updateTabTitleForFieldCodes: {
            title: true,
            firstname: true,
            lastname: true,
            nickname: true,
            type: true,
        },
        heartbeatRefreshOn: {
            'reconnect': true,
            'resourceChanged.bo_employees': true
        },
    },

    methods: {
        /**
         * this function is used to handle the different kinds of errors.
         * NOTE: if this function returns reject no error occurred (e.g., if the statusCode is 200)
         * NOTE: if this function resolves the given context is always the original context and NOT the error handling context.
         *
         * @param   context             {} - action perform context
         *          {
         *              component: ...
         *              [action]: ...
         *              error: {
         *                  statusCode: <statusCode>            mixed - status code || 'clientError'
         *                  name: <statusCode>                  string - error name
         *                  errorCode: <statusCode>             string - error code
         *                  message: <statusCode>               string - error message
         *                  details: <statusCode>               string - error details
         *                  [childErrors]: []                   [] - list of child errors
         *              },
         *              errorHandlingType: CONSTANTS.ERROR.HANDLING_TYPE[...]
         *                                      int - this error handling type defines the state of error handling
         *                                      e.g., has this error been thrown during error handling or has this error been thrown during custom error handling etc.
         *                                      NOTE: this flag will be filled by CONSTANTS.ERROR.HANDLING_TYPE
         *          }
         * @returns Promise
         */
        handleError: function(context){
            var baseError = utils.extractBaseError(context.error);

            if(
                baseError.statusCode == 409 &&
                baseError.errorCode == 'SEQUELIZE_UNIQUE_CONSTRAINT_ERROR' &&
                baseError.table == 'um_users' &&
                baseError.column == 'code'
            ){
                return this.performAction(
                    this.prepareAction('message', undefined, {
                        messageDisplay: {
                            message: 'error:addUser.codeAlreadyInUse'
                        }
                    }, {
                        rollbackContext: context,
                        statusControllerLoadingMessage: '',
                        statusControllerSavingMessage:  ''
                    })
                );
            }

            if(
                baseError.statusCode == 500 &&
                baseError.errorCode == 'SMS_PROVIDER_NOT_GRANTED'
            ){
                return this.performAction(
                    this.prepareAction('message', undefined, {
                        messageDisplay: {
                            message: 'error:employees.sms_provider_not_granted'
                        }
                    }, {
                        rollbackContext: context,
                        statusControllerLoadingMessage: '',
                        statusControllerSavingMessage:  ''
                    })
                );
            }

            context.errorUnhandled = true;
            return utils.promise.resolve(context);
        },

        /**
         * this function will be called after the form values has been changed.
         *
         * @param isRelationChange 		boolean - was the change related to a relation or not
         * @param changeDone 			boolean - has a change been done
         * @param fieldData 			{} - fieldData used to define what to do
         */
        onChange: function(isRelationChange, changeDone, fieldData){
            fieldData = fieldData || {}
            if(!this.config.creationMode && (this.config.updateTabTitleForFieldCodes || {})[fieldData.fieldCode || '']){
                this.updateTabTitle()
            }

            if(fieldData.fieldCode === 'type'){
                this.onTypeChange(fieldData.fieldValue)
            }
        },

        onTypeChange(type){
            const boundByRestTimes = getComponent(this.$.find('[data-field-code="boundByRestTimes"]'), true)
            const boundByRestTimesAttribute = this.getFieldValue('boundByRestTimes', 'live')

            if(type === 'internal'){
                this.$.addClass('isInternalEmployee')
            } else {
                this.$.removeClass('isInternalEmployee')
            }

            if(type === 'external'){
                this.$.addClass('isExternalEmployee')

                if(boundByRestTimes && (boundByRestTimesAttribute === null || boundByRestTimesAttribute === undefined)){
                    boundByRestTimes.select(0)
                }
            } else {
                this.$.removeClass('isExternalEmployee')

                if(boundByRestTimes && (boundByRestTimesAttribute === null || boundByRestTimesAttribute === undefined)){
                    boundByRestTimes.select(1)
                }
            }

            if(type === 'occasional'){
                this.$.addClass('isOccasionalEmployee')
            } else {
                this.$.removeClass('isOccasionalEmployee')
            }

            this.triggerFind('employeeTypeChanged', { type })
        },

        async showExport(baseActionKey, buttonContext, buttonMode, actionBossComponent, additionalData){
            if(buttonContext === 'employeeReports'){

                const employee = {
                    nickname: this.getFieldValue('nickname', 'live'),
                    firstname: this.getFieldValue('firstname', 'live'),
                    lastname: this.getFieldValue('lastname', 'live'),

                    type: this.getFieldValue('type', 'live'),
                    status: this.getFieldValue('status', 'live'),
                    domainCrew: this.getFieldValue('domainCrew', 'live'),
                    targetWorkingHoursPerWeek: this.getFieldValue('targetWorkingHoursPerWeek', 'live'),
                }

                if(!employee.type || employee.type !== 'internal' || employee.status !== 'active' || !employee.domainCrew || employee.targetWorkingHoursPerWeek <= 0 || (!employee.nickname && !employee.firstname && !employee.lastname)){
                    return await this.performMessage({
                        messageDisplay: {
                            message: 'error:employees.export.employeeReports.employeeNotSuitable'
                        }
                    })
                }

                await this.performAndStoreAction(
                    'showSelect_workingTimeExport_timeRange',
                    this.prepareAction(genericModalController.getAction({
                        component: [
                            '/',
                            'templates',
                            'core',
                            'modal',
                            'modal',
                        ],
                        config: {
                            decisionMaker: false,
                        },
                        model: {
                            titleKey: 'modal.showSelect_workingTimeExport_timeRange.title',
                            buttons: [
                                {
                                    mode: 'select',
                                    positive: true,
                                    buttonType: 'decisionComponent'
                                },
                                {
                                    buttonType: 'cancel',
                                    mode: 'abort'
                                }
                            ],
                        }
                    }, {
                        component: [
                            '/',
                            'templates',
                            'core',
                            'form',
                            'static',
                            'exportEmployeeReportSelectMonthStartTS',
                        ],
                    }))
                )
            }
        },

        async startExport(mode, additionalFilters, filename){
            const employee = {
                employeeID: this.getFieldValue('primaryKey', 'live'),
                nickname:   this.getFieldValue('nickname', 'live'),
                title:      this.getFieldValue('title', 'live'),
                firstname:  this.getFieldValue('firstname', 'live'),
                lastname:   this.getFieldValue('lastname', 'live'),
            }

            const filenameParts = []
            const employeeNameParts = []
            if(employee.nickname){
                employeeNameParts.push(employee.nickname)
            } else {
                if(employee.title){
                    employeeNameParts.push(employee.title)
                }
                if(employee.firstname){
                    employeeNameParts.push(employee.firstname)
                }
                if(employee.lastname){
                    employeeNameParts.push(employee.lastname)
                }
            }
            filenameParts.push(employeeNameParts.join('-') || 'UNKNOWN_EMPLOYEE')

            const {monthStartTS} = additionalFilters || {}
            if(monthStartTS){
                filenameParts.push(utils.moment(monthStartTS).format('MMMM-YYYY'))
            }

            filename = `${filenameParts.join('_')}.xlsx`

            const resourceFilters 	= {
                filters: {
                    employeeID: employee.employeeID,
                    ...(additionalFilters || {}),
                }
            }

            const url = `/LTR/~/exports/office/employeeReports/${mode || '-'}/${filename}?body=${Buffer.from(JSON.stringify({
                resourceFilters
            })).toString('base64')}`

            try {
                await downloader.download(url, filename)
            } catch (error) {
                return this.performMessage({
                    messageDisplay: {
                        message: 'error:employees.export.employeeReports.fileDownloadError'
                    }
                })
            }
        },

        /**
         * return userID which should be used as owner for fields used within this form.
         * e.g., file upload
         *
         * @param storage		actual storage
         * @returns mixed 		userID or null
         */
        getOwner(storage = false){
            // all media uploaded within this form should be owned by the corresponding employees user
            return {
                userID:         (((((this.resourceData.data || {}).children || {}).user || {}).data || {}).attributes || {}).userID || null,
                isServiceUser:  false
            }
        }
    },

    hooks: {
        _attach($element, options){
            this.onTypeChange(this.getFieldValue('type'))
        },

        async _onDecision($element, options){
            options = options || {}
            const decisionOptions = options.decisionOptions || {}
            const {decisionComponent} = options

            if(
                decisionComponent &&
                decisionComponent.hasClass('container_templates_core_form_static_exportEmployeeReportSelectMonthStartTS') &&
                decisionOptions.mode === 'select'
            ){
                const {monthStartTS} = decisionOptions

                if(!monthStartTS){
                    return await this.performMessage({
                        messageDisplay: {
                            message: 'error:employees.export.employeeReports.missingMonthStartTS'
                        }
                    })
                }

                const monthStartDiff = utils.moment(monthStartTS).diff(utils.moment().startOf('month'), 'days')
                if(monthStartDiff >= 0){
                    return await this.performMessage({
                        messageDisplay: {
                            message: 'error:employees.export.employeeReports.futureMonthStartTS'
                        }
                    })
                }

                await this.startExport('~', {
                    monthStartTS,
                })

                decisionComponent.hide()
            }
        },
    }
}